import styled from "styled-components";

export const Container = styled.div`
  border-bottom: solid 1px;
  border-color: ${({ theme }) => theme.colors.middleGrey};
  padding: 0 1rem;
`;
